module.exports = __webpack_public_path__ + "img/icon5.feaf2655.png";